module.exports = __webpack_public_path__ + "static/media/2020lehotzky.693b99cd.png";